module.exports = __webpack_public_path__ + "static/img/tsdje.0143138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/tsdje.png
// module id = uq07
// module chunks = 1